import { Payload, usePost } from 'api/reactQuery/queryService';
import { APIRoutes } from './constants';
import { IBinLotFacade } from 'api/swaggerTypes';
import { toObjectified } from 'api/baseApi';
import type { Inline } from 'api/utils';

const CalculateLotsParser = (response) => {
    return {
        ...response,
    };
};

const isObjectified = (value: any): boolean =>
    Boolean(value && typeof value === 'object' && 'inlineObject' in value && 'schema' in value);

const looksInlineSchema = (value: any): boolean => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return false;
    }

    // Inline schema objects typically have fields that are objects with `Value`/`Label`/`Display` metadata.
    return Object.values(value).some(
        (v: any) => v && typeof v === 'object' && ('Value' in v || 'Label' in v || 'Display' in v)
    );
};

const GetLotDetailsResponseParser = (response: any): any => {
    const lotDetail = response?.LotDetail;

    return {
        ...response,
        LotDetail: isObjectified(lotDetail)
            ? lotDetail
            : looksInlineSchema(lotDetail)
                ? toObjectified(lotDetail as unknown as Inline<any>)
                : lotDetail,
    };
};

export const useCalculateLots = () => {

    return usePost<Payload<{ ProductId: number; Warehouse: number } & any>, any>
        (APIRoutes.Lots.calculateLots, null, { responseParser: CalculateLotsParser });
};

export type LotDetailsCriteria = Partial<IBinLotFacade> & {
    FastLine?: boolean;
    SaveLocation?: boolean;
    [key: string]: any;
};

export interface IGetLotDetailsRequest {
    Initialise: boolean;
    LotCriteria: LotDetailsCriteria;
}

export const useGetLotDetails = () => {
    return usePost<Payload<{ ProductId: number } & IGetLotDetailsRequest>, any>(
        APIRoutes.Lots.getLotDetails,
        null,
        { inline: true, responseParser: GetLotDetailsResponseParser }
    );
};
